import type { FC } from 'react'
import styled from 'styled-components'

const SmallActivityImg = styled.img`
  border-radius: 100%;
  width: 40px;
  height: 40px;
  overflow: hidden;
  max-width: 200px;
  object-fit: cover;
  background: #f2f2f2;
  padding: 0px;
  min-width: 40px;
`

const SmallUserIconAvatar = styled.div`
  background: #34bebd;
  color: white;
  border-radius: 100%;
  height: 40px;
  width: 40px;
  text-align: center;
  display: grid;
  place-items: center;
  box-sizing: content-box;
  position: relative;
`

interface Props {
  name: string
  url?: string
}

export const avatarInitials = (nameOfUser: string): string => {
  if (nameOfUser.split(' ').length === 1) {
    return nameOfUser.split('')[0].toUpperCase()
  }
  if (nameOfUser.trim() === '') {
    return ''
  }
  return `${nameOfUser.split(' ')[0][0]}${nameOfUser.split(' ')[1][0]}`
    .replace('undefined', ' ')
    .toUpperCase()
}

const Avatar: FC<Props> = ({ url, name }) =>
  url ? (
    <SmallActivityImg src={url} />
  ) : (
    <SmallUserIconAvatar>
      {name.trim() !== '' && <span>{avatarInitials(name)}</span>}
    </SmallUserIconAvatar>
  )
export default Avatar
